@if (shouldRender()) {
<section class="hero-banner" [attr.aria-label]="title()">
  <div class="hero-banner__background">
    <img
      [ngSrc]="imageUrl()"
      [alt]="imageAlt()"
      fill
      class="hero-banner__image"
      loading="lazy"
    />
    <div class="hero-banner__overlay" aria-hidden="true"></div>
  </div>

  <div class="hero-banner__inner">
    <div class="hero-banner__content">
      @if (eyebrow()) {
        <p class="hero-banner__eyebrow">{{ eyebrow() }}</p>
      }

      <h2 class="hero-banner__title">{{ title() }}</h2>

      @if (subtitle()) {
        <p class="hero-banner__subtitle">{{ subtitle() }}</p>
      }

      @if (button(); as btn) {
        @if (isExternalButton()) {
          <a [href]="btn.url" class="hero-banner__cta">
            {{ btn.label }}
          </a>
        } @else {
          <a [routerLink]="btn.url" class="hero-banner__cta">
            {{ btn.label }}
          </a>
        }
      }
    </div>
  </div>
</section>
}
